import type {AxiosInstance} from "axios"
import axios from "axios"
import type {MetaHTMLAttributes} from "vue";

const apiInstance: AxiosInstance = axios.create({
    baseURL: '/api',
    timeout: 5000,
})

apiInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

//TODO: Wildcard
apiInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

apiInstance.defaults.headers.common["x-language"] = window.language;

let api_token: MetaHTMLAttributes | null = document.head.querySelector('meta[name="api-token"]') as MetaHTMLAttributes | null;
if (api_token) {
    apiInstance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    apiInstance.defaults.headers.common["Authorization"] = "Bearer " + api_token.content;
}

export function api(): AxiosInstance {
    return apiInstance
}
